import { AnchorButton } from '@blueprintjs/core';
import {
  ArrowDown,
  ArrowUp,
  ArrowsVertical,
  CarbonIconType,
} from '@carbon/icons-react';
import * as React from 'react';
import { Icon } from 'vet-bones/design-system/components';

import { DataTableColumn } from 'src/ui/components/DataTable';

export type DataTableHeaderCellProps<T> = {
  colIdx: number;
  column: DataTableColumn<T>;
  onSort: () => void;
  sortAsc: boolean;
  sortIdx: number;
};

export const DataTableHeaderCell = <T,>({
  colIdx,
  column,
  onSort,
  sortAsc,
  sortIdx,
}: DataTableHeaderCellProps<T>) => {
  let sortIcon: CarbonIconType | null = null;
  if (column.sortByAlpha || column.sortByNumeric) {
    if (sortIdx !== colIdx) {
      sortIcon = ArrowsVertical;
    } else if (sortAsc) {
      sortIcon = ArrowDown;
    } else {
      sortIcon = ArrowUp;
    }
  }
  return (
    <td
      key={column.key}
      className={column.className}
      data-testid={column.testId}
    >
      <div className="data-table-header-cell">
        <span>{column.header}</span>
        {sortIcon ? (
          <AnchorButton
            active={sortIdx === colIdx}
            className="data-table-header-button"
            data-testid={column.sortTestId}
            onClick={onSort}
          >
            <Icon IconComponent={sortIcon} size="sm" />
          </AnchorButton>
        ) : null}
      </div>
    </td>
  );
};
